var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":"50%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"monitorList-area"},[_c('div',{staticClass:"contents"},[_c('div',{staticClass:"canvas-img",attrs:{"id":"myDetailPlayer"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }